import React from "react";

import { Breadcrumbs } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { UserProvider } from "../../../../../context/UserContext";
import { MembersComponent } from "./Members";
import { MemberProvider } from "./Members/Member/context";
import Roles from "./Roles";
import useStyles from "./styles";
import Users from "./Users";
import Groups from "./Groups";

const PeopleTab = ({ tabName }: { tabName: string }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const renderHeader = () => {
    if (tabName !== t("members")) {
      return (
        <header className={classes.peopleHeader}>
          <Breadcrumbs
            data-cy="breadcrumbs"
            separator={<NavigateNext />}
            aria-label="breadcrumb"
            className={classes.peopleHeaderBreadcrumb}
          >
            <span data-cy="breadcrumbsTitle" className={classes.peopleHeaderBreadcrumbTitle}>
              {t("people")}
            </span>
            <span
              data-cy="breadcrumbsSubtitle"
              className={`${classes.peopleHeaderBreadcrumbTitle} active`}
            >
              {t(tabName)}
            </span>
          </Breadcrumbs>
        </header>
      );
    }

    return "";
  };

  const renderContent = () => {
    switch (tabName) {
      case "users":
        return (
          <UserProvider>
            <Users />
          </UserProvider>
        );
      case "members":
        return (
          <MemberProvider>
            <MembersComponent />
          </MemberProvider>
        );
      case "roles":
      case "accessRules":
        return <Roles />;
      case "groups":
        return <Groups />;
      default:
        return (
          <UserProvider>
            <Users />
          </UserProvider>
        );
    }
  };

  return (
    <div data-cy="peopleWrapper" className={classes.peopleWrapper}>
      {/* {renderHeader()} */}
      {renderContent()}
    </div>
  );
};

export default PeopleTab;
